import type { IconAsset } from '../Icon.types';

const code = (
  <g fill='currentColor' transform='translate(-212.357 -1122.082)'>
    <path d='M224.768,1143.465c-.986.01-5.614.051-6.065,0-.509-.062-1.384-.03-1.345-2.068s.679-10.246.841-10.661a1.418,1.418,0,0,1,1.434-.839h10.278a1.419,1.419,0,0,1,1.43.839c.161.415.8,8.628.839,10.661s-.835,2.006-1.342,2.066c-.169.019-.919.026-1.841.026C227.43,1143.49,225.386,1143.472,224.768,1143.465Z' />
    <path d='M227.418,1132.307a2.418,2.418,0,0,1-.071-.422,22.672,22.672,0,0,0-.78-3.817c-.482-1.5-1.09-2.361-1.671-2.361h-.007c-.65.009-1.329,1.126-1.809,2.989a22.079,22.079,0,0,0-.564,3.428l-1.625-.116a23.5,23.5,0,0,1,.612-3.717c.714-2.772,1.841-4.189,3.357-4.208h.033c1.389,0,2.47,1.174,3.214,3.489a24.232,24.232,0,0,1,.844,4.1c.012.092.026.2.03.226q-.008-.038-.018-.075Z' />
  </g>
);

export const bag: IconAsset = {
  regular: {
    l: {
      code,
    },
    m: {
      code,
    },
    s: {
      code,
    },
  },
};
